import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import cn from 'classnames';

import { Accordion, Card } from 'components';
import OrderHeader from 'components/layout/OrderHeader';

import ProductsList from 'src/features/ValuationsOrder/components/ProductsList';
import { addOrderDetails } from 'src/features/ValuationView/actions';
import { getFormattedAmount } from 'src/utils/helpers';

import OrderOptions from '../OrderOptions';
import OrderComment from '../SupplierComment';
import UserCommentAndGifts from '../UserCommentAndGifts';

import style from './OrderDetails.module.scss';
import shared from 'styles/Shared.module.scss';

const OrderDetails = ({ order }) => {
  const { name, payment, shipping, amount, shipping_price } = order;
  const [paymentId, setPaymentId] = useState(payment[0]?.id || null);
  const [shippingId, setShippingId] = useState(shipping[0]?.id || null);
  const [userComment, setUserComment] = useState('');

  const dispatch = useDispatch();

  const titleProductsList = <h3 className={cn(shared.tableCategoryTitle, shared.large, shared.noPadding)}>Lista produktów</h3>;
  const titlePaymentDelivery = (
    <h3 className={cn(shared.tableCategoryTitle, shared.large, shared.noPadding)}>Wysyłka i dostawa</h3>
  );
  const titleComment = <h3 className={cn(shared.tableCategoryTitle, shared.large, shared.noPadding)}>Komentarze</h3>;
  const titleSummary = <h3 className={cn(shared.tableCategoryTitle, shared.large, shared.noPadding)}>Podsumowanie</h3>;

  const handleDispatchOrderDetails = () =>
    dispatch(
      addOrderDetails({
        supplier_id: order.id,
        shipping_id: shippingId,
        payment_id: paymentId,
        user_comment: userComment
      })
    );

  useEffect(() => {
    if (paymentId && shippingId) {
      handleDispatchOrderDetails();
    }
  }, [paymentId, shippingId, order]);

  useEffect(() => {
    const timeoutId = setTimeout(handleDispatchOrderDetails, 500);
    return () => clearTimeout(timeoutId);
  }, [userComment]);

  return (
    <div
      className={style.supplier}
      id={name}
    >
      <OrderHeader supplier={order} />
      <Accordion
        section
        title={titleProductsList}
        id={`valuation-details-${order.id}`}
        extraDeps={[order.products]}
      >
        <ProductsList
          products={order.products}
          showAll
        />
      </Accordion>

      <OrderComment comment={order.comment} />
      <Accordion
        section
        title={titlePaymentDelivery}
        id={`valuation-payment-delivery-${order.id}`}
        extraDeps={[payment, shipping]}
      >
        <div className={style.container}>
          <OrderOptions
            groupName={`${order.name}-payment`}
            options={payment}
            setCurrentOption={setPaymentId}
            currentOption={paymentId}
            errorMessage={'Musisz wybrać sposób płatności'}
            sectionTitle={'Sposób płatności'}
          />
          <OrderOptions
            groupName={`${order.name}-shipping`}
            options={shipping}
            setCurrentOption={setShippingId}
            currentOption={shippingId}
            errorMessage={'Musisz wybrać sposób dostawy'}
            sectionTitle={'Sposób wysyłki'}
          />
        </div>
      </Accordion>
      <Accordion
        section
        title={titleComment}
        id={`valuation-comment-${order.id}`}
        extraDeps={[userComment]}
      >
        <UserCommentAndGifts
          setComment={setUserComment}
          comment={userComment}
          gifts={order.gifts}
        />
      </Accordion>
      <Accordion
        section
        title={titleSummary}
        id={`valuation-summary-${order.id}`}
        extraDeps={[amount, shipping_price]}
      >
        <Card className={cn(shared.defaultWrapper, style.card)}>
          <h2 className={style.partOfAmount}>Wartość produktów: {getFormattedAmount(amount)}</h2>
          <h2 className={style.partOfAmount}>Koszty wysyłki: {getFormattedAmount(shipping_price)}</h2>
          <h2 className={style.amount}>Suma zamówienia: {getFormattedAmount(amount + shipping_price)}</h2>
        </Card>
      </Accordion>
    </div>
  );
};

export default OrderDetails;
